// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"21506716","298":"b51325be","453":"e31f7240","472":"a2033eb9","484":"0ebeb038","790":"aee8c5a7","839":"37f05313","966":"f2ace19d"}[chunkId] + ".chunk.js";
};